export default __webpack_public_path__ + "static/media/B_04_01_map.3676e0d7.jpg";